import React from 'react';

import Empty from './Empty';
import Nav from './Nav';
import Footer from './Footer';

export default function Layout({ children }) {
  return (
    <>
      <Nav />
      <Empty />
      <div className="row">
        <div className="col s12 m12 l12 layout-wrapper">
          {children}
        </div>
      </div>
      <Footer />
    </>
  );
}
